/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const CircleCheck = ({
  fill = "var(--theme-colors-success-card-fg)",
}: {
  fill?: string;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.9165C6.10156 2.9165 4.39062 3.92432 3.45312 5.5415C2.49219 7.18213 2.49219 9.17432 3.45312 10.7915C4.39062 12.4321 6.10156 13.4165 8 13.4165C9.875 13.4165 11.5859 12.4321 12.5234 10.7915C13.4844 9.17432 13.4844 7.18213 12.5234 5.5415C11.5859 3.92432 9.875 2.9165 8 2.9165ZM8 14.1665C5.84375 14.1665 3.875 13.0415 2.79688 11.1665C1.71875 9.31494 1.71875 7.0415 2.79688 5.1665C3.875 3.31494 5.84375 2.1665 8 2.1665C10.1328 2.1665 12.1016 3.31494 13.1797 5.1665C14.2578 7.0415 14.2578 9.31494 13.1797 11.1665C12.1016 13.0415 10.1328 14.1665 8 14.1665ZM10.5078 6.94775L7.50781 9.94775L7.25 10.2056L6.96875 9.94775L5.46875 8.44775L5.21094 8.1665L5.75 7.65088L6.00781 7.90869L7.25 9.15088L9.96875 6.40869L10.25 6.15088L10.7656 6.6665L10.5078 6.94775Z"
        fill={fill}
      />
    </svg>
  );
};

export default CircleCheck;
